import { useState, createContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom';
import { isUserLoggedIn } from './Utils';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)

  const logIn = user => {
    setUser(user)
  }

  const logOut = () => {
    localStorage.removeItem("token");
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, logIn, logOut }}>
      { children }
    </AuthContext.Provider>
  )
}

export const RequireAuth = ({ children }) => {
  const location = useLocation();
  if (!isUserLoggedIn()) 
    return <Navigate to='/login' state={{ path: location.pathname }} />
  
  return children
}
